module.exports = __webpack_public_path__ + "static/media/IMG_4497 island.74b37460.JPG";